import { render, staticRenderFns } from "./editResultado.vue?vue&type=template&id=1b433024&scoped=true"
import script from "./editResultado.vue?vue&type=script&lang=js"
export * from "./editResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b433024",
  null
  
)

export default component.exports